import { render } from "./CountryRatings.vue?vue&type=template&id=2b6f8150"
import script from "./CountryRatings.vue?vue&type=script&lang=js"
export * from "./CountryRatings.vue?vue&type=script&lang=js"

import "./CountryRatings.vue?vue&type=style&index=0&id=2b6f8150&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__